<template>
    <a-layout id="chat" class="page_layout">
        <div class="chat_title">
            <a-alert type="info">
                <div slot="message" class="chat_p base_font_size_14 base_font_color_606266">
                    配置聊天工具栏，
                    <a-button type="link" @click="toPath('/word-help')" size="small">如何添加到聊天工具栏?</a-button>
                </div>
                <div slot="description" class="chat_p base_font_size_14 base_font_color_606266">
                    聊天素材：{{chatMaterialBaseUrl}}
                    <a-button type="link" @click="toCopy" size="small">点击复制地址</a-button>
                </div>
            </a-alert>
        </div>
        <a-layout>
            <a-layout-sider class="page_sider material_sider" theme="light">
                <div class="sider_cont">
                    <a-menu
                        mode="inline"
                        theme="light"
                        :defaultSelectedKeys="[0]"
                        @select="menuChange"
                    >
                        <template v-for="item in cateList">
                            <a-menu-item :key="item.categoryId" v-if="!item.children">
                                <a-row type="flex" justify="space-between" align="middle">
                                    <a-space :size="5">
                                        <!-- <a-icon type="folder" /> -->
                                        <a-tooltip
                                            :title="item.mark === 1 ? '加入话术' : '取消话术'"
                                            placement="topLeft"
                                        >
                                            <a-checkbox
                                                :indeterminate="item.isMark"
                                                :checked="item.mark === 1 ? false : true"
                                                @change="cateChange(item)"
                                                v-if="item.categoryId !== 0"
                                            />
                                        </a-tooltip>
                                        <a-tooltip
                                            :title="item.categoryName"
                                            :arrowPointAtCenter="false"
                                            placement="topLeft"
                                            autoAdjustOverflow
                                        >
                                            <span class="cate_name">{{ item.categoryName }}</span>
                                        </a-tooltip>
                                    </a-space>
                                    <!-- <a-space :size="0" class="cate_name_active">
                                        <a-icon type="edit" @click="toEditCategory(item)"></a-icon>
                                        <a-icon
                                            type="delete"
                                            @click="toDelCategory(item.categoryId)"
                                        ></a-icon>
                                    </a-space> -->
                                </a-row>
                            </a-menu-item>
                            <a-sub-menu :key="item.categoryId" v-else>
                                <template slot="title">
                                    <a-row type="flex" justify="space-between" align="middle">
                                        <a-space :size="5">
                                            <!-- <a-icon type="folder" /> -->
                                            <a-tooltip
                                                :title="item.mark === 1 ? '加入话术' : '取消话术'"
                                                placement="topLeft"
                                            >
                                                <a-checkbox
                                                    :indeterminate="item.isMark"
                                                    :checked="item.mark === 1 ? false : true"
                                                    @change="cateChange(item)"
                                                    v-if="item.categoryId !== 0"
                                                />
                                            </a-tooltip>
                                            <a-tooltip
                                                :title="item.categoryName"
                                                :arrowPointAtCenter="false"
                                                placement="topLeft"
                                                autoAdjustOverflow
                                            >
                                                <span class="cate_name">
                                                    {{ item.categoryName }}
                                                </span>
                                            </a-tooltip>
                                        </a-space>
                                        <!-- <a-space :size="0" class="cate_name_active">
                                            <a-icon
                                                type="edit"
                                                @click="toEditCategory(item)"
                                            ></a-icon>
                                            <a-icon
                                                type="delete"
                                                @click="toDelCategory(item.categoryId)"
                                            ></a-icon>
                                        </a-space> -->
                                    </a-row>
                                </template>
                                <template v-for="el in item.children">
                                    <a-menu-item :key="el.categoryId">
                                        <a-row type="flex" justify="space-between" align="middle">
                                            <a-space :size="5">
                                                <a-tooltip
                                                    :title="el.mark === 1 ? '加入话术' : '取消话术'"
                                                    placement="topLeft"
                                                >
                                                    <a-checkbox
                                                        :indeterminate="el.isMark"
                                                        :checked="el.mark === 1 ? false : true"
                                                        @change="cateChange(el)"
                                                        v-if="el.categoryId !== 0"
                                                    />
                                                </a-tooltip>
                                                <a-tooltip
                                                    :title="el.categoryName"
                                                    :arrowPointAtCenter="false"
                                                    placement="topLeft"
                                                    autoAdjustOverflow
                                                >
                                                    <span class="cate_name">{{ el.categoryName }}</span>
                                                </a-tooltip>
                                            </a-space>
                                            <!-- <a-space :size="0" class="cate_name_active">
                                                <a-icon
                                                    type="edit"
                                                    @click="toEditCategory(item)"
                                                ></a-icon>
                                                <a-icon
                                                    type="delete"
                                                    @click="toDelCategory(el.categoryId)"
                                                ></a-icon>
                                            </a-space> -->
                                        </a-row>
                                    </a-menu-item>
                                </template>
                            </a-sub-menu>
                        </template>
                    </a-menu>
                </div>
                <!-- <div class="sider_bottom">
                    <a-button type="link" @click="cateModal = true">添加分类</a-button>
                </div> -->
            </a-layout-sider>
            <a-layout-content class="page_content material_content single">
                <div class="page_header material_header cross_center">
                    <a-checkbox
                        :indeterminate="mediaTypeSelect.length === 4 ? false : true"
                        :checked="mediaTypeSelect.length === 4 ? true : false"
                        :size="0"
                        @change="checkAll"
                    >
                        全部类型
                        <a-divider type="vertical" />
                    </a-checkbox>
                    <a-checkbox-group v-model="mediaTypeSelect" @change="mediaTypeChange">
                        <a-checkbox :value="item.value" v-for="(item, index) in mediaType" :key="item.value">
                            <a-icon :type="item.icon" style="margin-right: 3px;"></a-icon>
                            <span>{{ item.label }}</span>
                            <a-divider type="vertical" v-if="index !== (mediaType.length - 1)" />
                        </a-checkbox>
                    </a-checkbox-group>
                </div>
                <a-list
                    item-layout="horizontal"
                    :data-source="dataList"
                    rowKey="id"
                    :pagination="dataList.length > 0 ? pagination : false"
                >
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-list-item-meta>
                            <a-space slot="avatar" size="middle">
                                <a-checkbox
                                    :checked="item.isSelected"
                                    :disabled="item.mark === 1 ? false : true"
                                    @change="singleChange(item)"
                                />
                                <a-avatar
                                    shape="square"
                                    :size="100"
                                    icon="file-text"
                                    v-if="item.mediaType === 'text'"
                                />
                                <a-avatar
                                    shape="square"
                                    :size="100"
                                    icon="file"
                                    v-else-if="item.mediaType === 'file'"
                                />
                                <a-avatar
                                    shape="square"
                                    :size="100"
                                    icon="sound"
                                    v-else-if="item.mediaType === 'voice'"
                                />
                                <a-avatar
                                    shape="square"
                                    :size="100"
                                    icon="video-camera"
                                    v-else-if="item.mediaType === 'video'"
                                />
                                <a-popover placement="right" overlayClassName="picture_over" v-else>
                                    <template slot="content">
                                        <img :src="item.cover" style="width: 300px" />
                                    </template>
                                    <a-avatar shape="square" :size="100" :src="item.cover" />
                                </a-popover>
                                <a-tag>
                                    {{
                                        mediaType.find((el) => {
                                            return el.value === item.mediaType;
                                        }).label
                                    }}
                                </a-tag>
                                <a-card :bordered="false">{{ item.title }}</a-card>
                            </a-space>
                        </a-list-item-meta>
                        <a-button-group size="small" slot="actions">
                            <a-button type="link" @click="updateMaterial(item)">
                                {{item.mark === 1 ? '加入话术' : '取消话术'}}
                            </a-button>
                            <!-- <a-button type="link" @click="toEditItem(item)">编辑</a-button>
                            <a-divider type="vertical" />
                            <a-button type="link" @click="toDelItem(item.id)">删除</a-button> -->
                        </a-button-group>
                    </a-list-item>
                    <div slot="footer" class="list_foot cross_center" v-if="dataList.length > 0">
                        <a-space :size="5">
                            <a-checkbox
                                :indeterminate="checkedHaveBtn"
                                :checked="checkedAllBtn"
                                @change="checkListAll"
                            >
                                全选
                            </a-checkbox>
                            <a-button @click="importMaterial(2)">
                                批量加入话术
                            </a-button>
                        </a-space>
                    </div>
                </a-list>
            </a-layout-content>
        </a-layout>
        <a-modal
            title="添加分类"
            :visible="cateModal"
            @cancel="toCancelCategory"
            @ok="toCheckCategory"
        >
            <a-form-model :model="formData">
                <a-form-model-item label="上级分类">
                    <a-tree-select
                        v-model="formData.parentId"
                        :treeData="cateList"
                        :replaceFields="{
                            children: 'children',
                            title: 'categoryName',
                            key: 'categoryId',
                            value: 'categoryId'
                        }"
                        placeholder="上级分类"
                        show-search
                        allow-clear
                    ></a-tree-select>
                </a-form-model-item>
                <a-form-model-item label="分类名称">
                    <a-input v-model="formData.categoryName" placeholder="分类名称" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <materialModal
            ref="material"
            :title="materialModalTitle"
            :type="mediaTypeForModal"
            @change="initMaterial"
        ></materialModal>
    </a-layout>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import materialModal from '@/components/group/materialModal';
export default {
    name: 'chat',
    components: {
        materialModal
    },
    data() {
        return {
            chatMaterialBaseUrl: process.env.VUE_APP_CHAT_MATERIAL_BASEURL,
            cateModal: false,
            dataModal: false,
            materialModalTitle: '',
            mediaTypeForModal: '',
            // ['text', 'image', 'link', 'wxapp', 'file']
            mediaTypeSelect: ['text', 'image', 'link', 'file'],
            cateList: [],
            dataList: [],
            // 初始dataList中筛选出mark = 1的所有元素，方便后续，有选中元素判断checkedHaveBtn状态
            dataMarkEq1: [],
            // 是否展示有元素选中
            checkedHaveBtn: false,
            // 是否全选
            checkedAllBtn: false,
            searchData: {
                mediaType: 'text|image|link|file',
                page: 1
            },
            formData: {},
            pagination: {
                onChange: page => {
                    this.searchData.page = page;
                    this.initMaterial();
                },
                total: 0
            },
            mediaType: [
                { label: '文本', value: 'text', icon: 'file-text' },
                { label: '图片', value: 'image', icon: 'picture' },
                { label: '网页', value: 'link', icon: 'link' },
                // { label: '语音', value: 'voice', icon: 'sound' },
                // { label: '视频', value: 'video', icon: 'video-camera' },
                // { label: '小程序', value: 'wxapp', icon: 'deployment-unit' },
                { label: '文件', value: 'file', icon: 'file' }
            ],
            // 批量加入素材
            batchMaterial: [],
        };
    },
    watch: {
        batchMaterial(val, oldVal) {
            if (val.length > 0 && val.length < this.dataMarkEq1.length) {
                this.checkedHaveBtn = true;
                this.checkedAllBtn = false;
            } else if (val.length > 0 && val.length === this.dataMarkEq1.length) {
                this.checkedHaveBtn = false;
                this.checkedAllBtn = true;
            } else {
                this.checkedHaveBtn = false;
                this.checkedAllBtn = false;
            }
        }
    },
    mounted() {
        this.initCategory();
        this.initMaterial();
    },
    methods: {
        // 初始数据
        async initCategory() {
            try {
                const res = await api.getCategory();
                if (res.code !== 0) return;
                this.cateList = [...[{ categoryId: 0, categoryName: '全部' }], ...res.category];
            } catch (err) {
                console.log(err);
            }
        },
        async initMaterial() {
            try {
                const res = await api.getMaterial(this.searchData);
                if (res.code !== 0) return;
                this.pagination.total = res.count;
                this.dataMarkEq1 = [];
                res.rows.forEach(item => {
                    item.isSelected = item.mark === 1 ? false : true;
                    if (item.mark === 1) this.dataMarkEq1.push(item);
                    return item;
                });
                if (res.rows && res.rows.length === 0) {
                    this.checkedHaveBtn = false;
                    this.checkedAllBtn = false;
                }
                this.dataList = res.rows;
            } catch (err) {
                console.log(err);
            }
        },
        // 分类弹框
        toEditCategory(item) {
            this.formData = item;
            this.cateModal = true;
        },
        async toCheckCategory() {
            try {
                if (this.formData.categoryId) {
                    let res = await api.updateCategory(this.formData);
                    if (res.code !== 0) return;
                    this.$message.success('修改成功');
                } else {
                    let res = await api.postCategory(this.formData);
                    if (res.code !== 0) return;
                    this.$message.success('添加成功');
                }
                this.toCancelCategory();
                this.initCategory();
            } catch (err) {
                console.log(err);
            }
        },
        toCancelCategory() {
            this.cateModal = false;
            this.formData = {};
        },
        // 列表弹框
        toUpload({ key }) {
            this.mediaTypeForModal = key;
            this.materialModalTitle = '添加' + _.find(this.mediaType, ['value', key]).label;
            this.$refs.material.open();
        },
        toEditItem(item) {
            this.mediaTypeForModal = item.mediaType;
            this.materialModalTitle =
                '编辑' + _.find(this.mediaType, ['value', item.mediaType]).label;
            this.$refs.material.open(item);
        },
        // 操作
        async toDelCategory(categoryId) {
            let that = this;
            try {
                this.$confirm({
                    title: `确认删除？`,
                    icon: 'info-circle',
                    async onOk() {
                        let res = await api.delCategory({ categoryId });
                        if (res.code !== 0) return;
                        that.$message.success('删除成功');
                        that.initCategory();
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        async toDelItem(materialId) {
            let that = this;
            try {
                this.$confirm({
                    title: `确认删除？`,
                    icon: 'info-circle',
                    async onOk() {
                        let res = await api.delMaterial({ materialId });
                        if (res.code !== 0) return;
                        that.$message.success('删除成功');
                        that.initMaterial();
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        mediaTypeChange(e) {
            if (e.length === 0) this.mediaTypeSelect = ['text'];
            this.searchData.mediaType = this.mediaTypeSelect.join('|');
            this.searchData.page = 1;
            this.initMaterial();
            this.batchMaterial = [];
        },
        menuChange({ item, key }) {
            if (key) {
                this.searchData.categoryId = key;
            } else {
                delete this.searchData.categoryId;
            }
            this.searchData.page = 1;
            this.initMaterial();
        },
        // 权限素材类型
        checkAll(e) {
            if (e.target.checked) {
                this.searchData.mediaType = 'text|image|link|file';
                this.searchData.page = 1;
                this.mediaTypeSelect = ['text', 'image', 'link', 'file'];
            } else {
                this.searchData.mediaType = 'text';
                this.searchData.page = 1;
                this.mediaTypeSelect = ['text'];
            }
            this.initMaterial();
            this.batchMaterial = [];
        },
        // 更新素材
        async updateMaterial(data) {
            const that = this;
            const params = {
                categoryId: data.categoryId,
                materialId: data.id,
                mark: data.mark === 1 ? 2 : 1
            };
            const desc = data.mark === 1 ? '加入聊天话术' : '取消聊天话术';
            try {
                this.$confirm({
                    title: `确认${desc}？`,
                    icon: 'info-circle',
                    async onOk() {
                        let res = await api.updateMaterial(params);
                        if (res.code !== 0) return;
                        that.$message.success('成功' + desc);
                        that.initMaterial();
                        that.initCategory();
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 列表全选
        checkListAll(e) {
            this.batchMaterial = [];
            this.dataList.forEach(item => {
                if (item.mark === 1 && !item.isSelected) {
                    item.isSelected = e.target.checked;
                    this.batchMaterial.push(item);
                } else if (item.mark === 1 && item.isSelected) {
                    item.isSelected = e.target.checked;
                }
                return item;
            });
            if (this.batchMaterial.length === 0 && e.target.checked) this.$message.error('当前没有可加入话术');
        },
        singleChange(data) {
            this.dataList.forEach(item => {
                if (item.mark === 1 && item.id === data.id) {
                    item.isSelected = !item.isSelected;
                    const batcIndex = _.indexOf(this.batchMaterial, data);
                    if (batcIndex > -1) {
                        this.batchMaterial.splice(batcIndex, 1);
                    } else {
                        this.batchMaterial.push(item);
                    }
                    return item;
                }
            });
        },
        // 批量加入/取消话术
        async importMaterial(markStatus) {
            if (this.batchMaterial.length > 0) {
                this.batchMaterial.forEach(async (item, index) => {
                    const params = {
                        categoryId: item.categoryId,
                        materialId: item.id,
                        mark: markStatus
                    };
                    const res = await api.updateMaterial(params);
                    if (index === this.batchMaterial.length - 1 && res.code === 0) {
                        this.$message.success(markStatus === 2 ? '成功批量加入话术。' : '成功批量取消话术。');
                        this.initMaterial();
                        this.initCategory();
                        this.batchMaterial = [];
                    }
                });
            } else {
                this.$message.error('请先选择需要加入的话术素材。');
            }
        },
        // 分类更新是否加入话术
        async cateChange(data) {
            const that = this;
            const params = {
                categoryId: data.categoryId,
                categoryName: data.categoryName,
                parentId: data.parentId,
                mark: data.mark === 1 ? 2 : 1,
                editMark: 1
            };
            const desc = data.mark === 1 ? '加入聊天话术' : '取消聊天话术';
            try {
                this.$confirm({
                    title: `确认${desc}？`,
                    icon: 'info-circle',
                    async onOk() {
                        let res = await api.updateCategory(params);
                        if (res.code !== 0) return;
                        that.$message.success('成功' + desc);
                        that.initMaterial();
                        that.initCategory();
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 复制
        toCopy() {
            //创建一个 Input标签 
            let oInput = document.createElement('input');
            oInput.value = this.chatMaterialBaseUrl;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            console.log(oInput.value)
            // 执行浏览器复制命令
            /// 复制命令会将当前选中的内容复制到剪切板中
            /// 如这里构建的 Input标签 
            document.execCommand("Copy"); 
            this.$message.success('复制成功！');
            ///复制成功后再将构造的标签 移除
            oInput.remove();
        },
        // 跳转路由
        toPath(url) {
            if (url) this.$router.push({
                path: url
            });
        },
    }
};
</script>

<style>
#chat .material_content {
    padding: 0 30px;
}
#chat .material_sider {
    background: #fff;
    position: relative;
    padding: 0 0 30px 0;
}
#chat .ant-list {
    /* height: 200px; */
    margin-bottom: 30px;
}
#chat .ant-list .ant-spin-container {
    max-height: calc(100vh - 440px);
    overflow-y: auto;
}
#chat .material_sider .ant-layout-sider-children {
    border-right: 1px solid #e8e8e8;
}
#chat .material_sider .sider_cont {
    height: calc(100% - 32px);
    overflow-y: auto;
}
#chat .material_sider .sider_cont::-webkit-scrollbar {
    display: none;
}
#chat .material_sider .sider_cont .ant-menu-inline {
    border-right: 0 none;
}
#chat .material_sider .sider_bottom {
    width: 100%;
    text-align: center;
}
#chat .material_header {
    /* background: #fff; */
    border-bottom: 1px solid #e8e8e8;
    height: 44px;
    padding: 0;
}
#chat .cate_name {
    display: inline-block;
    vertical-align: middle;
    width: 80px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
#chat .ant-menu-item .ant-row-flex,
#chat .ant-menu-submenu .ant-row-flex {
    position: relative;
    z-index: 999;
}
#chat .cate_name_active {
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
    pointer-events: none;
}
#chat .cate_name_active .ant-space-item .anticon {
    margin-right: 5px;
}
#chat .cate_name_active .ant-space-item:last-child .anticon {
    margin-right: 0;
}
#chat .ant-menu-submenu-active .ant-menu-submenu-title .cate_name_active,
#chat .ant-menu-item-active .cate_name_active {
    opacity: 1;
    pointer-events: auto;
}
.picture_over .ant-popover-inner-content {
    padding: 5px;
}
#chat .ant-list-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0;
}
#chat .ant-list-footer .list_foot {
    height: 32px;
}
#chat .chat_title {
    padding: 30px 30px 15px 30px;
    background-color: #fff;
}
#chat .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
}
</style>
